import { SETTINGS_NAV_GROUPS } from './settingsNavGroups.js'

export function getSettingsNavItemById(id) {
  for (const group of SETTINGS_NAV_GROUPS) {
    const item = group.items.find((i) => i.id === id)
    if (item) return item
  }
  return undefined
}
